// Which games are downloaded for offline play (the files live in Cache Storage).
const STORAGE_KEY = "akedo_offline_games_v1";

const read = () => {
	try {
		const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
		return value && typeof value === "object" ? value : {};
	} catch (_) {
		return {};
	}
};

const write = (games) => {
	localStorage.setItem(STORAGE_KEY, JSON.stringify(games));
	window.dispatchEvent(new Event("akedo-offline-games-changed"));
};

export const listOfflineGames = () =>
	Object.values(read()).sort((a, b) => (b.downloadedAt || 0) - (a.downloadedAt || 0));

export const getOfflineGame = (appId) => read()[appId] || null;

export const saveOfflineGame = (game) => write({ ...read(), [game.id]: game });

export const removeOfflineGameEntry = (appId) => {
	const games = read();
	delete games[appId];
	write(games);
};

// Offline mode (and its service worker) is on once a game is downloaded.
export const hasOfflineGames = () => Object.keys(read()).length > 0;
